module.exports = __webpack_public_path__ + "img/corporate-3.b1f80902.jpg";